import { HONG_KONG_SALES_ORG } from './constants';

import { maxLength3, maxLength6 } from './formValidations';

/**
 * @name getHongKongOrTaiwanPostalCodeMaxLength
 * @desc Get the max number of postal code digits for HK and TW. Used by the Address Book and in Checkout
 * @param {String} salesOrg the sales org of the selected account
 */
const getHongKongOrTaiwanPostalCodeMaxLength = salesOrg =>
  salesOrg === HONG_KONG_SALES_ORG ? [maxLength3] : [maxLength6];

export default getHongKongOrTaiwanPostalCodeMaxLength;
